import type { ReactNode } from 'react'
import React, { createContext, useContext as useContextCore } from 'react'
import type { DragSortHandleProps } from '@ztechapps/webui.util'

type HandlePropsContextValue = DragSortHandleProps | null

const HandlePropsContext = createContext<HandlePropsContextValue>(null)

type HandlePropsProviderProps = {
  value: HandlePropsContextValue
  children: ReactNode
}

export const HandlePropsProvider = ({ value, children }: HandlePropsProviderProps) => (
  <HandlePropsContext.Provider value={value}>{children}</HandlePropsContext.Provider>
)

export const useHandleProps = (): HandlePropsContextValue => useContextCore(HandlePropsContext)
